import { render, staticRenderFns } from "./VolumeReportTemplate.vue?vue&type=template&id=9dc5c796"
import script from "./VolumeReportTemplate.vue?vue&type=script&lang=js"
export * from "./VolumeReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./VolumeReportTemplate.vue?vue&type=style&index=0&id=9dc5c796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports